import { MembershipsCreateParams } from "@api/models/EventMemberShip";
import { EventMembershipRepository } from "@api/repositories/EventMembershipRepository";
import { Store } from "vuex";

export interface EventMembershipsServiceInterface {
    create(params: MembershipsCreateParams): void;
    delete(membershipsIds: string[]): void;
}

export class EventMembershipsService implements EventMembershipsServiceInterface {
    constructor(
        private eventMembershipRepository: EventMembershipRepository,
        private store: Store<any>
    ) {

    }

    create(params: MembershipsCreateParams) {
        try {
            this.eventMembershipRepository.create(params);
        }
        catch(e) {
            this.store.dispatch('reportException', e, { root: true });
        }

    }

    delete(membershipsIds: string[]) {
        try {
            this.eventMembershipRepository.delete(membershipsIds);
        }
        catch(e) {
            this.store.dispatch('reportException', e, { root: true });
        }
    }
}